import { create } from 'zustand';
import { ApiUtils, CardApi, type CardEntity, type StoreBaseReturn } from '@shared/api';

interface UseReplaceCardStore {
  loading: boolean;
  data: CardEntity[];
  error: string | null;
  replaceCard: (accountId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<CardEntity[]>>;
  clear: () => void;
}

export const useReplaceCardStore = create<UseReplaceCardStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  replaceCard: async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.replaceCard(accountId, signal);
      set({ loading: false, data: result || [] });
      return { loading: false, data: result || [], error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: [], error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: [], error: null }),
}));
